import { Logtail } from '@logtail/browser';

export class LogHelper {
  info(logtail: Logtail, message: string, meta?: Record<string, unknown>): void {
    logtail.info(message, meta);
  }

  error(logtail: Logtail, message: string, meta?: Record<string, unknown>): void {
    logtail.error(message, meta);
  }

  warn(logtail: Logtail, message: string, meta?: Record<string, unknown>): void {
    logtail.info(message, meta);
  }

  log(logtail: Logtail, message: string, logLevel: string, meta?: Record<string, unknown>): void {
    logtail.log(message, logLevel, meta);
  }

  debug(logtail: Logtail, message: string, meta: Record<string, unknown>): void {
    logtail.debug(message, meta);
  }

  flush(logtail: Logtail): void {
    logtail.flush();
  }
}

export default new LogHelper();
